// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-GiveawayWinnerModal-module__winnerContainer-pD6g8 {
  height: 400px;
  position: relative;
}

.nightbot-GiveawayWinnerModal-module__winnerMessages-vmKVd {
  height: 100%;
  display: flex;
  gap: 8px;
  flex-direction: column;
  overflow-y: scroll;
  padding: 16px;
}

.nightbot-GiveawayWinnerModal-module__waitingMessages-s0RpA {
  height: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
  color: var(--text-secondary);
  --text-color: var(--text-secondary);
  background: linear-gradient(0deg, var(--background-secondary) 0%, var(--background-primary) 100%);
}

.nightbot-GiveawayWinnerModal-module__waitingMessages-s0RpA .nightbot-GiveawayWinnerModal-module__waitingMessagesNotice-SwR40 {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
  }

.nightbot-GiveawayWinnerModal-module__modalTitle-qJyrQ {
  display: flex;
  padding: 16px;
  gap: 16px;
  align-items: center;
}

.nightbot-GiveawayWinnerModal-module__winnerInfo-y08CF {
  display: flex;
  flex-direction: column;
}

.nightbot-GiveawayWinnerModal-module__winnerInfo-y08CF .nightbot-GiveawayWinnerModal-module__followingStatus-ofguY {
    color: var(--text-secondary);
    --text-color: var(--text-secondary);
  }

.nightbot-GiveawayWinnerModal-module__activeStatus-emz1w {
  height: -moz-fit-content;
  height: fit-content;
  margin-left: auto;
  background-color: var(--background-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-secondary);
  padding: 0px 4px;
  border-radius: var(--mantine-radius-md);
}

.nightbot-GiveawayWinnerModal-module__winnerActive-u6_aw {
  color: var(--color-success);
}

.nightbot-GiveawayWinnerModal-module__message-XLD8W {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.nightbot-GiveawayWinnerModal-module__timestamp-QwbSa {
  color: var(--text-secondary);
  --text-color: var(--text-secondary);
}

.nightbot-GiveawayWinnerModal-module__messageText-fyjG3 {
  overflow: hidden;
  word-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/giveaways/GiveawayWinnerModal.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EAAnB,qBAAmB;EAAnB,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;EACnC,iGAAiG;AAQnG;;AANE;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;AAGF;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AAMxB;;AAJE;IACE,4BAA4B;IAC5B,mCAAmC;EACrC;;AAGF;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,0BAA0B;EAC1B,yCAAyC;EACzC,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":[".winnerContainer {\n  height: 400px;\n  position: relative;\n}\n\n.winnerMessages {\n  height: 100%;\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n  overflow-y: scroll;\n  padding: 16px;\n}\n\n.waitingMessages {\n  height: 100%;\n  display: grid;\n  place-items: center;\n  color: var(--text-secondary);\n  --text-color: var(--text-secondary);\n  background: linear-gradient(0deg, var(--background-secondary) 0%, var(--background-primary) 100%);\n\n  .waitingMessagesNotice {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    align-items: center;\n  }\n}\n\n.modalTitle {\n  display: flex;\n  padding: 16px;\n  gap: 16px;\n  align-items: center;\n}\n\n.winnerInfo {\n  display: flex;\n  flex-direction: column;\n\n  .followingStatus {\n    color: var(--text-secondary);\n    --text-color: var(--text-secondary);\n  }\n}\n\n.activeStatus {\n  height: fit-content;\n  margin-left: auto;\n  background-color: var(--background-secondary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-secondary);\n  padding: 0px 4px;\n  border-radius: var(--mantine-radius-md);\n}\n\n.winnerActive {\n  color: var(--color-success);\n}\n\n.message {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.timestamp {\n  color: var(--text-secondary);\n  --text-color: var(--text-secondary);\n}\n\n.messageText {\n  overflow: hidden;\n  word-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"winnerContainer": `nightbot-GiveawayWinnerModal-module__winnerContainer-pD6g8`,
	"winnerMessages": `nightbot-GiveawayWinnerModal-module__winnerMessages-vmKVd`,
	"waitingMessages": `nightbot-GiveawayWinnerModal-module__waitingMessages-s0RpA`,
	"waitingMessagesNotice": `nightbot-GiveawayWinnerModal-module__waitingMessagesNotice-SwR40`,
	"modalTitle": `nightbot-GiveawayWinnerModal-module__modalTitle-qJyrQ`,
	"winnerInfo": `nightbot-GiveawayWinnerModal-module__winnerInfo-y08CF`,
	"followingStatus": `nightbot-GiveawayWinnerModal-module__followingStatus-ofguY`,
	"activeStatus": `nightbot-GiveawayWinnerModal-module__activeStatus-emz1w`,
	"winnerActive": `nightbot-GiveawayWinnerModal-module__winnerActive-u6_aw`,
	"message": `nightbot-GiveawayWinnerModal-module__message-XLD8W`,
	"timestamp": `nightbot-GiveawayWinnerModal-module__timestamp-QwbSa`,
	"messageText": `nightbot-GiveawayWinnerModal-module__messageText-fyjG3`
};
export default ___CSS_LOADER_EXPORT___;
